import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import Btn from "../components/Btn/Btn";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Scenery = () => {
  return (
    <React.Fragment>
      <SEO title="Scenery | ICSI 2024" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Scenery"
        content="For Participants"
        contentTwo="Scenery"
        linkage="/"

      />

      <EmptyTwo>
        {/* <div className="entry-content title-center">
          <h2>The information is to be announced. </h2>
        </div> */}
        <div className="entry-content2">
          {/* <div className="ch-lang-en">
          <Link className="btn btn-primary" to={process.env.PUBLIC_URL + "/scenery_zn"}>Chinese</Link>
          </div> */}
          <div className="space-50"></div>
          <h2>About Qinghai Province</h2>
          <br></br>
          <p className="font-black font-bold" align="justify">
            Qinghai /tʃɪŋˈhaɪ/, ching-HY (青海; alternately romanized as Tsinghai, Ch&apos;inghai), also known as Kokonor, is a landlocked province in the northwest of the People&apos;s Republic of China. It is the largest province of China by area and has the third smallest population. Its capital and largest city is Xining.
            <br />
            <br />

            Qinghai borders Gansu on the northeast, Xinjiang on the northwest, Sichuan on the southeast and the Tibet Autonomous Region on the southwest. Qinghai province was established in 1928 during the period of the Republic of China, and until 1949 was ruled by Chinese Muslim warlords known as the Ma clique. The Chinese name &quot;Qinghai&quot; is after Qinghai Lake, the largest lake in China. The lake is known as Tso ngon in Tibetan, and as Kokonor Lake in English, derived from the Mongol Oirat name for Qinghai Lake. Both Tso ngon and Kokonor are names found in historic documents to describe the region.
            <br />
            <br />
            Located mostly on the Tibetan Plateau, the province is inhabited by a number of peoples including the Tibetans, Mongols, Han (concentrated in the provincial capital of Xining and nearby Haidong), Hui, Monguors, and Salars. According to the 2021 census reports, Tibetans constitute a fifth of the population of Qinghai and the Hui compose roughly a sixth of the population. There are over 37 recognized ethnic groups among Qinghai&apos;s population of 5.6 million, with national minorities making up a total of 49.5% of the population.
            <br />
            <br />

            The area of Qinghai came under the control of the Manchu-led Qing Dynasty around 1724, after their defeat of Khoshut Mongols who previously controlled most of the area. After the Xinhai Revolution and the ensuing fall of the Qing dynasty in 1912, Qinghai came under Chinese Muslim warlord Ma Qi&apos;s control until the Northern Expedition by the Republic of China consolidated central control in 1928. In the same year, the province of Qinghai was established by the Nationalist Government, with Xining as its capital.
            <br></br>
            <br></br>


          </p>

          <br></br>

          <h3>Attractions in Qinghai</h3>
          <br></br>
          <li>
            <a href="#talent-park">Qinghai Lake</a>
          </li>
          <li>
            <a href="#windows">Chaka Salt Lake</a>
          </li>
          <li>
            <a href="#folk-village">Ta&apos;er Temple</a>
          </li>
          {/* <li>
            <a href="#shenzhenbay">Shenzhen Bay Park</a>
          </li> */}



          <br />
          <br />
          <h4 id="talent-park">Qinghai Late</h4>
          <p align="justify">
            Qinghai Lake, also known as Lake Kokonor, is a magnificent natural wonder located in the northeastern part of the Qinghai-Tibet Plateau in China. It is the largest saltwater lake in China and the largest inland lake in the country.

            With an average elevation of over 3,200 meters (10,500 feet) above sea level, Qinghai Lake offers breathtaking views of pristine blue waters surrounded by picturesque landscapes. The lake spans an area of approximately 4,500 square kilometers (1,700 square miles), making it an expansive and awe-inspiring sight to behold.
            <br />
            <br />

            Qinghai Lake holds great ecological significance as it serves as a crucial habitat for numerous bird species, including the endangered black-necked crane. It is also home to a diverse range of flora and fauna, making it a paradise for nature lovers and wildlife enthusiasts.

            The surrounding region is characterized by its unique and diverse geographical features, including grasslands, wetlands, and rolling hills. Visitors to Qinghai Lake can explore the surrounding areas, indulge in outdoor activities like hiking and biking, or simply marvel at the stunning vistas and tranquility that the lake offers.
            <br />
            <br />

            In addition to its natural beauty, Qinghai Lake holds cultural and historical importance. It is surrounded by several Tibetan Buddhist monasteries, such as the famous Bird Island, where visitors can immerse themselves in the rich Tibetan culture and witness traditional rituals and ceremonies.

            Whether it is the awe-inspiring landscapes, the rich biodiversity, or the cultural heritage, Qinghai Lake offers an unforgettable experience for travelers seeking to connect with nature and explore the wonders of the Qinghai-Tibet Plateau.
            <br />
            <br />
          </p>
          <p>
            <div className="title-center">
              <img
                src="./images/xn/qhlake.jpg"
                alt="talent-park"
                width="90%"
              />
            </div>
          </p>
          <br></br>
          <br></br>
          <h4 id="windows">Chaka Salt Lake</h4>
          <p align="justify">
            Chaka Salt Lake, located in western China&apos;s Qinghai Province, is a mesmerizing natural wonder renowned for its stunning salt formations and vast expanse of crystalline landscapes. It is often referred to as the &quot;Mirror of the Sky&quot; due to its mirror-like reflections that create an ethereal and surreal atmosphere.
            <br></br>
            <br></br>
            Covering an area of approximately 105 square kilometers (40 square miles), Chaka Salt Lake is one of the largest salt lakes in China. Its unique geological conditions have led to the formation of a thick layer of salt crust, resulting in a mesmerizing mosaic of geometric patterns that stretch as far as the eye can see.

            Visitors to Chaka Salt Lake are greeted with a breathtaking sight of shimmering white salt flats contrasted against clear blue skies. The lake&apos;s surface reflects the surrounding mountains, clouds, and the vibrant colors of the sky, creating a visual spectacle that captivates photographers and nature enthusiasts alike.
            <br></br>
            <br></br>
            The lake&apos;s salt crust is not only a visual delight but also a valuable natural resource. The salt is harvested by local communities, contributing to the region&apos;s economy and providing insight into the traditional salt production methods that have been practiced for centuries.

            Exploring Chaka Salt Lake allows visitors to immerse themselves in the unique salt landscape, walk on the salt flats, and even participate in salt-related activities such as salt sculpture making. The area also offers opportunities for photography, as the ever-changing light conditions create stunning reflections and shadows on the salt surface.
            <br></br>
            <br></br>
            Beyond its natural beauty, Chaka Salt Lake is surrounded by a vibrant Tibetan culture. Visitors can experience the local Tibetan traditions, taste traditional cuisine, and witness colorful festivals that showcase the rich heritage of the region.

            Chaka Salt Lake stands as a testament to the awe-inspiring diversity of natural landscapes in China. Its surreal beauty, cultural significance, and the opportunity for unique experiences make it a must-visit destination for travelers seeking to be enchanted by the wonders of the natural world.
          </p>
          <div className="title-center">
            <p>
              <img
                src="./images/xn/chaka.jpg"
                alt="windows of world"
                width="90%"
              />
              <br />
            </p>

          </div>

          <br></br>
          <br></br>

          <h4 id="folk-village">Ta&apos;er Temple</h4>
          <p align="justify">
            Ta&apos;er Temple, also known as Kumbum Monastery, is a renowned Tibetan Buddhist monastery located in Qinghai Province, China. Situated in the picturesque Huangzhong County, it is considered one of the most important religious sites in the region and holds great historical and cultural significance.
            <br></br>
            <br></br>

            Established in the 16th century, Ta&apos;er Temple is closely associated with Tsongkhapa, the founder of the Gelug sect of Tibetan Buddhism. The monastery&apos;s architecture showcases a blend of Tibetan and Chinese styles, with its golden roofs, colorful murals, and ornate decorations creating a visually striking and spiritually uplifting environment.

            The main highlight of Ta&apos;er Temple is the grand Assembly Hall, which houses a magnificent statue of Maitreya Buddha, standing at a remarkable height of 26 meters (85 feet). The hall is adorned with intricate Tibetan Buddhist artwork, including thangka paintings and sculptures, depicting various deities and enlightened beings.
            <br></br>
            <br></br>
            The monastery complex comprises multiple prayer halls, living quarters for monks, meditation rooms, and courtyards, all of which contribute to a serene and tranquil atmosphere. Visitors can witness the daily rituals of the resident monks, listen to their melodic chanting, and even engage in meditation practices to experience the essence of Tibetan Buddhism.

            Ta&apos;er Temple is also famous for its Butter Sculpture Festival, held annually during the Tibetan New Year. This vibrant celebration showcases elaborate butter sculptures crafted by skilled artisans, depicting scenes from Buddhist mythology and Tibetan culture. The festival attracts numerous devotees and tourists who come to admire the intricate artwork and participate in religious ceremonies.
            <br></br>
            <br></br>
            Surrounded by scenic mountains and picturesque landscapes, Ta&apos;er Temple offers not only a spiritual retreat but also a breathtaking natural setting. The nearby Riyue Mountain provides an excellent vantage point to appreciate the panoramic views of the temple complex and the surrounding countryside.

            A visit to Ta&apos;er Temple provides an opportunity to delve into Tibetan Buddhist teachings, witness centuries-old traditions, and gain a deeper understanding of Tibetan culture and spirituality. It stands as a testament to the enduring legacy of Tibetan Buddhism in China and continues to attract pilgrims and travelers seeking spiritual enlightenment and cultural exploration.
          </p>

          <div className="title-center">
            <p>
              <img src="./images/xn/temple.jpg" alt="folk-village" width="90%" />

              <br />
            </p>

          </div>

          <br></br>
          <br></br>

          {/* <h4 id="wutong">Wutong Mountain Scenic Area </h4>
          <p align="justify">
            With an area of 31.82 square kilometres, founded in 1989 and situated in central south part of Shenzhen, Mount Wutong National Park nears the Roc Bay of South China Sea in the east, connects Hong Kong in the south, borders on Shenzhen Reservoir in the west, approaches the secondary boundaries of the pre-Shenzhen Special Economic Zone in the north.
            <br></br>
            <br></br>

            Wutong Mountain is a rare natural scenic spot in China, which is located in urban area, with coastal mountains and natural vegetations as its main scenery. There are eight scenery blocks such as &quot;Musical Instrument in Phoenix Valley&quot;, &quot;Wutong Clouds&quot;, &quot;A Phoenix Perching on the Green Wutong&quot;, &quot;East Lake Park&quot; and &quot;Fairy Lake Botanical Garden&quot; etc. In 1993 it was awarded the title of National Park of Guangdong by the Guangdong Provincial Government. In December 2009, it was conferred the title of National Park of China by the State Council.
          </p>

          <div className="title-center">
            <p>
              <img
                src="./images/shenzhen/shenzhen2.jpg"
                alt="wutong"
                width="90%"
              />
              <br />
            </p>

          </div>

          <br></br>
          <br></br>

          <h4 id="dameisha">Dameisha Beach</h4>
          <p align="justify">
            Dameisha Beach Park is one of ten tangible things promoised by the Shenzhen government. Located in Yantan District of Shenzhen, Dameisha Seashore Park embraces the Mirs Bay and owns 1,800 meters long beach. Sun Square is located in the heart of the park while Moon Square lays in the west of the park. A 432-meter long passage connects these two parks. More than 50 kinds of subtropical trees are planted in the park, including coconut tree and palm, ect.. There are many functional zones in the park, like swimming zone, sport zone, amusement zone and BBQ zone.
          </p>
          <br></br>

          <div className="title-center">
            <p>
              <img src="./images/shenzhen/shenzhen3.jpg" alt="dameisha" width="90%" />
              <br />
            </p>

          </div>
          <br></br>
          <br></br> */}

          {/* <h4 id="shenzhenbay">Shenzhen Bay Park</h4>
          <p>Shenzhen Bay Park is a seaside urban park in Shenzhen. The park occupies a 13-kilometer-long stretch of reclaimed land along the southern coast of Shenzhen on the north shore of Shenzhen Bay (Deep Bay), starting west near Shenzhen Bay Bridge at Wanghai road and ending at the Hongshulin Nature Reserve. It spans much of the coastline of the Nanshan and Futian districts. It runs along much of the length of Binhai and Binhe Boulevards and occupies an area of 108.07 hectares (267.0518 acres).

        The park is divided into two sections, namely Shenzhen Bay Coastal Recreation Zone (深圳湾滨海休闲带) at its South West side and Hongshulin Coastal Ecological Park (红树林海滨生态公园) at its Eastern side. The latter is situated within the Hongshulin Nature Reserve, a habitat of numerous endangered bird species and is also known for its mangrove.

        The entire area of the park opened on August 6, 2011, days before the 2011 Summer Universiade that took place in Shenzhen. The Hongshulin Coastal Ecological Park was opened earlier in December 2000. The entire length of the park is motor vehicle-free. Cycle paths and picnic spaces are featured along the park. The park offers a panoramic view covering the Shenzhen skyline and New Territories, Hong Kong.
          </p>
        <br></br>
        <div className="title-center">
          <p>
            <img src="./images/xian/sc8.jpg" alt="shenzhenbay" width="100%" />
            <br />
          </p>
        </div> */}

        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Scenery;
